import React, { FC } from 'react'
import isEmpty from 'lodash/isEmpty'
import { useStoreState } from 'easy-peasy'
import newRelic from '@mortgage-pos/ui/services/newRelic'
import PhoneIcon from '@mortgage-pos/ui/assets/PhoneIconDark.png'
import EmailIcon from '@mortgage-pos/ui/assets/EmailIconDark.png'
import { formatPhoneNumber, unformatPhoneNumber } from '@mortgage-pos/utils'

interface Props {
  productName?: string
}

const handleOnLinkClick = ({ target }) => {
  const type = target.dataset.contacttype || ''
  newRelic.increment(`successCard.${type}Link.clicked`)
}

const SuccessCard: FC<Props> = ({ productName }) => {
  const state = useStoreState((state) => state.loanOfficer)
  const {
    headshot = '',
    name = '',
    email = '',
    phone = '',
  } = state?.loanOfficer || {}

  return !isEmpty(state?.loanOfficer) ? (
    <div data-testid="success-card" className="success-card">
      <img src={headshot} className="success-card__headshot" alt="headshot" />

      <p className="success-card__title">
        Your loan officer:
        <br />
        {name}
      </p>

      <div className="success-card__contact-items">
        <div className="success-card__contact">
          <img
            className="success-card__contact-icon"
            src={EmailIcon}
            alt="email-icon"
          />
          <a
            href={`mailto: ${email}`}
            onClick={handleOnLinkClick}
            data-contactype="email"
            data-testid="success-card-email"
            className="success-card__contact-text"
          >
            {email}
          </a>
        </div>

        <div className="success-card__contact">
          <img
            className="success-card__contact-icon"
            src={PhoneIcon}
            alt="phone-icon"
          />
          <a
            href={`tel:+1${unformatPhoneNumber(phone)}`}
            onClick={handleOnLinkClick}
            data-contactype="phone"
            data-testid="success-card-phone"
            className="success-card__contact-text"
          >
            {formatPhoneNumber(phone)}
          </a>
        </div>
      </div>
    </div>
  ) : null
}

export default SuccessCard
